var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowForSplitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.535156 0H32.5352C36.9534 0 40.5352 3.58172 40.5352 8V32C40.5352 36.4183 36.9534 40 32.5352 40H0.535156V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4773_30361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.37085,
    y: 8,
    width: 24.019,
    height: 24,
    fill: "#6148f6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4773_30361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3806 23.6773C21.2638 23.6773 21.1514 23.6563 21.0433 23.6143C20.9346 23.573 20.8385 23.5107 20.7551 23.4273L16.2515 18.9273C16.1014 18.7773 16.0264 18.6023 16.0264 18.4023C16.0264 18.2023 16.1014 18.0273 16.2515 17.8773C16.4017 17.7273 16.5768 17.6523 16.777 17.6523C16.9771 17.6523 17.1523 17.7273 17.3024 17.8773L21.3806 21.9523L25.4588 17.8773C25.6089 17.7273 25.7841 17.6523 25.9842 17.6523C26.1844 17.6523 26.3595 17.7273 26.5097 17.8773C26.6598 18.0273 26.7348 18.2023 26.7348 18.4023C26.7348 18.6023 26.6598 18.7773 26.5097 18.9273L22.0061 23.4273C21.9227 23.5107 21.827 23.573 21.7189 23.6143C21.6101 23.6563 21.4974 23.6773 21.3806 23.6773Z",
    fill: "#5C5F62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowForSplitButton);
export default __webpack_public_path__ + "static/media/downArrowForSplitButton.c9d64e4deaf65998408b6790676579d5.svg";
export { ForwardRef as ReactComponent };